import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { routeDepth } from "utils";
import axios from "axios";
import { store, loadStore } from "store";
var DeviceView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceView, _super);
    function DeviceView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.routeTransition = "slide-left";
        _this.device = null;
        _this.product = null;
        _this.showScrollIndicator = false;
        return _this;
    }
    Object.defineProperty(DeviceView.prototype, "viewContainer", {
        get: function () { return this.$refs.viewContainer; },
        enumerable: true,
        configurable: true
    });
    DeviceView.prototype.created = function () {
        this.$root.$on("check-scroll-indicator", this.checkScrollIndicator);
    };
    DeviceView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.device = store.devices.find(function (d) { return d.serial == _this.$route.params.serial; });
                        if (!this.device) {
                            this.$router.push("/");
                            return [2 /*return*/];
                        }
                        if (!!this.product) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, axios.get("devices/by-serial", { params: { serial: this.device.serial, locale: this.$i18n.locale } })];
                    case 1:
                        _a.product = (_b.sent()).data;
                        if (!this.product) {
                            this.$router.push("/");
                            return [2 /*return*/];
                        }
                        this.$watch("$route", function (to, from) {
                            _this.routeTransition = (routeDepth(to) < routeDepth(from)) ? "slide-right" : "slide-left";
                            _this.showScrollIndicator = false;
                        });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DeviceView.prototype.beforeDestroy = function () {
        this.$root.$off("check-scroll-indicator", this.checkScrollIndicator);
    };
    DeviceView.prototype.viewTransitionAfterLeave = function () {
        if (this.viewContainer)
            this.viewContainer.scrollTo(0, 0);
    };
    DeviceView.prototype.checkScrollIndicator = function () {
        var _this = this;
        Vue.nextTick(function () {
            _this.showScrollIndicator = (_this.viewContainer && (_this.viewContainer.scrollHeight > _this.viewContainer.clientHeight));
        });
    };
    DeviceView.prototype.viewContainerScroll = function () {
        this.showScrollIndicator = false;
    };
    DeviceView.prototype.remove = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1, index;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$showDialog({
                            text: this.$t("deviceView.confirmRemoveDevice"),
                            buttons: [
                                { title: this.$t("common.remove"), result: true },
                                { title: this.$t("common.cancel"), result: false },
                            ],
                        })];
                    case 1:
                        if (!(_a.sent())) {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 6]);
                        return [4 /*yield*/, axios.post("devices/removeUserDevice", {
                                serialNumber: this.device.serial,
                                token: store.sessionToken,
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        err_1 = _a.sent();
                        return [4 /*yield*/, this.$showDialog({ text: this.$t("deviceView.errorRemovingUserDevice") })];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                    case 6:
                        index = store.deviceTemp.indexOf(this.device);
                        if (index != -1) {
                            store.deviceTemp.splice(index, 1);
                        }
                        return [4 /*yield*/, loadStore()];
                    case 7:
                        _a.sent();
                        this.$router.push({ name: "Start" });
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceView = tslib_1.__decorate([
        Component
    ], DeviceView);
    return DeviceView;
}(Vue));
export default DeviceView;
